import * as React from "react";
import { TooltipHost } from "@fluentui/react";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { ArrowClockwise20Regular } from "../_v2/components/SvgIcons/ArrowClockwise20Regular";

// const refreshIcon: IIconProps = {
//   iconName: "refresh",
//   styles: iconStyles
// };

// const actionButtonStyles: IButtonStyles = {
//   root: { padding: 0, height: 25 }
// }

const refreshButtonStyles: React.CSSProperties = {
  height: 25,
  marginRight: 4
}

interface SubTitleRefreshButtonProps {
  onClick: () => void;
}

const SubTitleRefreshButton: React.FunctionComponent<SubTitleRefreshButtonProps> = ({
  onClick,
}: SubTitleRefreshButtonProps) => {
  const languageStrings = React.useContext(LanguageContext);
  return (
    <TooltipHost content={languageStrings.Refresh} styles={{ root: { display: "inline-flex" } }}>
      {/* <ActionButton
        iconProps={refreshIcon}
        styles={actionButtonStyles}
        allowDisabledFocus
        onClick={(event) => {
          event.stopPropagation();
          onClick();
        }}
      /> */}
      <ArrowClockwise20Regular
        style={refreshButtonStyles}
        onClick={(event) => {
          event.stopPropagation();
          onClick();
        }}
      />
    </TooltipHost>
  );
};

export default SubTitleRefreshButton;